<div class="top-controls" *ngIf="paginatedTickets.length > 0">
    <div class="top-bar">
        <div class="left">
            <single-choice
                [topic]="'multi-action'"
                [ticketId]="1"
                [editMode]="true"
                [completedUrl]="actionUrlObserver"
                [choiceObserver]="actionIdObserver"
                [icon]="'checklist'"
                (choiceEvent)="relaySingleChoice($event)"
                [labelOnDemand]="actionLabelerByService"
                ></single-choice>
        </div>

        <div class="center">
            <div class="pagination-controls">
                <button
                    *ngFor="let page of getPaginationButtons()"
                    [disabled]="page === currentPage"
                    (click)="page !== '...' && goToPage(+page)"
                    >
                    {{ page === "..." ? "..." : + page + 1 }}
                </button>
            </div>
        </div>

        <div class="right">
            <button class="plus" (click)="createTicket()">
                <i class="fa fa-plus" aria-hidden="true"></i>
            </button>
        </div>
    </div>
</div>
<div class="table-container" [ngClass]="{ 'half-screen': selectedTicket }">
    <div class="table-scroll">
        <table>
            <thead></thead>
            <tbody>
                <tr
                    *ngFor="let ticket of paginatedTickets"
                    (click)="select(ticket)"
                    [class.selected]="ticket === selectedTicket"
                    >
                    <td>
                        <div class="all">
                            <div>
                                <span class="ticket-date">{{ dateFormatted(ticket) }}</span>
                            </div>
                            <div class="top-row">
                                <input
                                    class="check"
                                    type="checkbox"
                                    [checked]="isSelected(ticket)"
                                    (click)="toggleSelect(ticket); $event.stopPropagation()"
                                    />

                                <span class="ticket-title">{{ ticket.title }}</span>
                            </div>
                            <div class="bottom-row">
                                <dependent-choice
                                    *ngIf="isValidChoice(ticket.statusId)"                                    class="sts"
                                    [topic]="'status'"
                                    [icon]="'check_circle'"
                                    [reduced]="TRUE"
                                    [isTicketContext]="TRUE"
                                    [showLabel]="TRUE"
                                    [selectedId]="ticket.statusId"
                                    [labelOnDemand]="statusLabelerByService"
                                    ></dependent-choice>
                                <dependent-choice
                                    *ngIf="isValidChoice(ticket.departmentId)"                                    class="dep"
                                    [topic]="'departments'"
                                    [icon]="'apartment'"
                                    [reduced]="TRUE"
                                    [isTicketContext]="TRUE"
                                    [showLabel]="TRUE"
                                    [selectedId]="ticket.departmentId"
                                    [choiceObserver]="departmentIdObserver"
                                    [labelOnDemand]="departmentLabelerByService"
                                    ></dependent-choice>
                                <dependent-choice
                                    *ngIf="isValidChoice(ticket.branchId)"
                                    class="dc"
                                    [topic]="'branches'"
                                    [icon]="'domain'"
                                    [reduced]="TRUE"
                                    [isTicketContext]="TRUE"
                                    [showLabel]="TRUE"
                                    [selectedId]="ticket.branchId"
                                    [labelOnDemand]="branchLabelerByService"
                                    ></dependent-choice>
                                <div class="space">
                                    <dependent-choice
                                        *ngIf="isValidChoice(ticket.priorityId)"
                                        class="prio"
                                        [topic]="'priority'"
                                        [icon]="'flag'"
                                        [reduced]="TRUE"
                                        [isTicketContext]="TRUE"
                                        [showLabel]="TRUE"
                                        [selectedId]="ticket.priorityId"
                                        [labelOnDemand]="priorityLabelerByService"
                                        ></dependent-choice>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="isEmptyResult" class="ticket-empty">
            <div class="icon-empty">
                <span class="material-icons-outlined">confirmation_number</span>
            </div>
        </div>
    </div>
    <div class="pagination-info" *ngIf="paginatedTickets.length > 0">
        <span>{{ 'pagination.page' | translate }} {{ currentPage + 1 }} {{ 'pagination.of' | translate }} {{ totalPages }}</span>
        <span class="row">
            {{ startRow + 1 }} {{ 'pagination.to' | translate }} {{ endRow }} {{ 'pagination.of' | translate }} {{ tickets.value.length }}
        </span>
    </div>
</div>